import { render, staticRenderFns } from "./PaymentsBreakdownModal.vue?vue&type=template&id=747ca120&"
import script from "./PaymentsBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./PaymentsBreakdownModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsBreakdownModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports